import {AfterViewInit, Component} from '@angular/core';
import {MapViewStore}             from '../../stores/layout/mapview.store';

@Component({
  selector: 'ap-soil-scan',
  template: `
    <ap-section-header>
      <ap-section-header-grid
        [iconId]="'ap-icon-fields'"
        [caption]="'Global__SoilScanner'"
        [filterPlaceholder]="''"
        [filterTooltip]=""
        [createText]="'Docu_Ini__New'"
        [svg]=""
        [showCanCreateButton]="false"
        [canCreate]="false"
        [canSearch]="false"
      ></ap-section-header-grid>
    </ap-section-header>
    <div style="width:100%;height:100%">
      <img style="height:auto; width:100%; max-width: 1300px; padding:10px;"
           src="assets/img/comingsoon/bodenscanner.jpg">
    </div>
  `
})

export class ApSoilScanComponent implements AfterViewInit {
  constructor(private mapViewStore: MapViewStore) {
  }

  ngAfterViewInit(): void {

  }
}
